import "./BatteryTasks.scss";
import { regular, solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { memo, useEffect, useState } from "react";
import {
    Alert,
    Breadcrumb,
    Card,
    Col,
    Container,
    ListGroup,
    Row,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { Batteries } from "../../api/Batteries";
import AppLoader from "../../components/AppLoader";
import { useToasts } from "../../contexts/toasts";
import { Battery } from "../../models/Battery";
import { Task } from "../../models/Task";

type Props = {
    task: Task;
    actions: React.ReactNode;
};

const TaskItem = memo(({ task, actions }: Props) => {
    return (
        <ListGroup.Item className="d-flex align-items-center">
            <div className="me-3">
                <FontAwesomeIcon icon={regular("check-circle")} size="lg" fixedWidth />
            </div>

            <Col>
                <h6 className="mb-0">{task.name}</h6>
            </Col>

            <Col md={3} className="text-end">
                {actions}
            </Col>
        </ListGroup.Item>
    );
});

export default function BatteryDetail() {
    const { t } = useTranslation();
    const { id } = useParams();

    const [battery, setBattery] = useState<Battery | null>();
    const { showToast } = useToasts();

    useEffect(() => {
        initBattery();
        // eslint-disable-next-line
    }, []);

    /*     const initTasks = () => {
            Tasks.getTasks().then(
                ({ data: tasks }) => setTasks(tasks),
                (err) => {
                    const message = err.response?.data?.message || err.message;
                    const status = err.response?.status;
                    showToast!(
                        "tasks-error",
                        message,
                        `Tasks Error ${status ? `(${status})` : ""}`,
                        "danger"
                    );
                }
            );
        }; */


    const initBattery = () => {
        Batteries.getBattery(id!).then(
            ({ data: battery }) => {
                setBattery(battery);
            },
            (err) => {
                const message = err.response?.data?.message || err.message;
                const status = err.response?.status;
                showToast!(
                    "battery-error",
                    message,
                    `Battery Error ${status ? `(${status})` : ""}`,
                    "danger"
                );
            }
        );
    };

    const renderBatteryTasks = () => {
        if (battery!.tasks.length === 0)
            return (
                <Alert className="py-2 mb-0">
                    <FontAwesomeIcon icon={solid("info-circle")} />
                    <span className="ms-2">No tasks in this battery.</span>
                </Alert>
            );

        return (
            <div>
                {battery?.tasks!?.length > 0 && (
                    <ListGroup>
                        {battery?.tasks.map((task, j) => (
                            <TaskItem
                                key={task.id}
                                task={task}
                                actions={<></>}
                            />
                        ))}
                    </ListGroup>
                )}
            </div>
        );
    };

    const renderCardContent = () => {
        return (
            <>
                <Card.Body className="">
                    <Row>
                        <Col>
                            <div className="d-flex align-items-center mb-2">
                                <Col md={4}>
                                    <h6 className="mb-0">Battery Code</h6>
                                </Col>
                                <Col md={8}>
                                    <p className="mb-0">{battery!.code}</p>
                                </Col>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="d-flex align-items-center mb-2">
                                <Col md={4}>
                                    <h6 className="mb-0">Battery Description</h6>
                                </Col>
                                <Col md={8}>
                                    <p className="mb-0">{battery!.description}</p>
                                </Col>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="d-flex align-items-center mb-2">
                                <Col md={4}>
                                    <h6 className="mb-0">Battery Target</h6>
                                </Col>
                                <Col md={8}>
                                    <p className="mb-0">{battery!.target}</p>
                                </Col>
                            </div>

                        </Col>
                    </Row>
                    <hr></hr>
                    <Row>
                        <Col>
                            <div className="d-flex align-items-center mb-2">
                                <Col>
                                    <h6 className="mb-0">Battery Tasks</h6>
                                </Col>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="d-flex align-items-center mb-2">
                                <Col>
                                    {renderBatteryTasks()}
                                </Col>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </>
        );
    };

    const renderAsyncContent = () => {
        return battery ? (
            renderCardContent()
        ) : (
            <div className="d-flex py-3 justify-content-center">
                <AppLoader size={150} />
            </div>
        );
    };

    return (
        <Container>
            <Breadcrumb>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: `/batteries` }}>
                    {t("pages.batteries")}
                </Breadcrumb.Item>
                <Breadcrumb.Item active>
                    {battery?.name}
                </Breadcrumb.Item>
            </Breadcrumb>

            <Card>{renderAsyncContent()}</Card>
        </Container>
    );
}
